export default __webpack_public_path__ + "static/media/PulseRateLineOne.7bf4c9bc.svg";